export default __webpack_public_path__ + "digital_red-e0b736dc26b4f91e63755861d06fb9d9.xml";